"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReportAConcernPdf = void 0;
var _renderer = require("@react-pdf/renderer");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- not testable */ /* eslint-disable @typescript-eslint/prefer-nullish-coalescing -- we want to add - as fallback */ /* eslint-disable react/no-array-index-key -- only possible in this case */ const ReportAConcernPdf = (param)=>{
    let { title, footer, dataCollection } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.Document, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_renderer.Page, {
            size: "A4",
            style: _styles.styles.body,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.View, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.Text, {
                        style: _styles.styles.title,
                        children: title
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.View, {
                    style: _styles.styles.collection,
                    children: dataCollection.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)(_renderer.View, {
                            style: _styles.styles.questionBlock,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.Text, {
                                    style: _styles.styles.question,
                                    children: "".concat(index + 1, ". ").concat(item.questionText)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.Text, {
                                    style: _styles.styles.answer,
                                    children: item.responseText || '-'
                                })
                            ]
                        }, index))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_renderer.Text, {
                    fixed: true,
                    style: _styles.styles.footer,
                    children: footer
                })
            ]
        })
    });
};
exports.ReportAConcernPdf = ReportAConcernPdf;
